/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import classNames from 'classnames';
import { IconName } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';
import HeaderButton from 'app/gamma/src/components/header/button';
import { NotificationsPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import { showPopover, State } from 'app/gamma/src/modules';
import {
  loadNotificationGroups,
  loadUnreadNotificationsCount,
} from 'app/gamma/src/modules/loaders/load-notifications';
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import FavIcon from 'app/scripts/lib/favicon.coffee';
import { memberHasOtherNotifications } from 'app/gamma/src/selectors/members';
import { getUnseenNotificationsCount } from 'app/gamma/src/selectors/notifications';
import { isPopoverShown } from 'app/gamma/src/selectors/popovers';
import styles from './styles.less';

const HeaderNotificationsMenuPromise = import(/* webpackChunkName: "notifications-menu-popover" */ 'app/gamma/src/components/popovers/header-notifications-menu');
const HeaderNotificationsMenu = lazy(() => HeaderNotificationsMenuPromise);

interface NotificationsMenuButtonProps {
  isActive: boolean;
  loadNotificationGroups: () => void;
  onClick: (isActive: boolean) => void;
  loadUnreadNotificationsCount: () => void;
  hasOtherNotifications: boolean;
  unreadNotificationsCount: number;
}

export class NotificationsMenuButtonUnconnected extends React.Component<
  NotificationsMenuButtonProps
> {
  notificationsMenuButtonRef = React.createRef<HTMLButtonElement>();

  componentDidMount() {
    this.props.loadUnreadNotificationsCount();
    this.props.loadNotificationGroups();
  }

  componentDidUpdate(prevProps: NotificationsMenuButtonProps) {
    if (
      prevProps.unreadNotificationsCount === 0 &&
      !this.props.hasOtherNotifications &&
      this.props.unreadNotificationsCount > 0
    ) {
      FavIcon.setNotifications(true);
    }

    if (
      prevProps.unreadNotificationsCount > 0 &&
      !this.props.hasOtherNotifications &&
      this.props.unreadNotificationsCount === 0
    ) {
      FavIcon.setNotifications(false);
    }
  }

  render() {
    const {
      hasOtherNotifications,
      isActive,
      onClick,
      unreadNotificationsCount,
    } = this.props;

    return (
      <>
        <HeaderButton
          icon={IconName.Notification}
          onClick={() => onClick(isActive)}
          ref={this.notificationsMenuButtonRef}
          testId={HeaderTestIds.NotificationsButton}
          className={classNames({
            [styles.newNotifications]:
              !hasOtherNotifications && unreadNotificationsCount > 0,
            [styles.hasOtherNotifications]: hasOtherNotifications,
          })}
        />
        {isActive && (
          <Suspense fallback={null}>
            <HeaderNotificationsMenu
              target={() => this.notificationsMenuButtonRef.current}
            />
          </Suspense>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    isActive: isPopoverShown(state, NotificationsPopoverId),
    unreadNotificationsCount: getUnseenNotificationsCount(state),
    hasOtherNotifications: memberHasOtherNotifications(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>) => {
  return {
    loadNotificationGroups() {
      dispatch(loadNotificationGroups());
    },
    onClick(isActive: boolean) {
      trackUe({
        category: Noun.HEADER,
        verb: isActive ? Verb.CLOSES : Verb.OPENS,
        directObj: Noun.NOTIFICATIONS_MENU,
        method: 'by clicking the header button',
      });
      dispatch(showPopover({ name: NotificationsPopoverId }));
    },
    loadUnreadNotificationsCount() {
      dispatch(loadUnreadNotificationsCount());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationsMenuButtonUnconnected);
